import { useState } from "react";
import Login from "./Login";
import Dashboard from "./Dashboard";

function App() {
  const [user, setUser] = useState(null);

  if (!user) {
    return <Login onLogin={(usuarioAutorizado) => setUser(usuarioAutorizado)} />;
  }

  return <Dashboard user={user} onLogout={() => setUser(null)} />;
}

export default App;
